export function isExternal(href = "", origin = "") {
  if (origin && href.startsWith(origin)) {
    return false;
  }
  return /^(mailto:|tel:|\/media|http|www)/.test(href);
}
export function toRelativeUrl(url = "") {
  return url.replace(/^https?:\/\/[^/]*/gm, "");
}
export function slugify(text = "") {
  if (typeof text !== "string") {
    return "";
  }
  return text.toLowerCase().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/[àáâä]/g, "a").replace(/ç/g, "c").replace(/[èéêë]/g, "e").replace(/[îï]/g, "i").replace(/[ôö]/g, "o").replace(/[ùûü]/g, "u").replace(/æ/g, "ae").replace(/œ/g, "oe").replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/-{2,}/g, "-").replace(/^-+/, "").replace(/-+$/, "");
}
export function getUrlExtension(url) {
  if (!url) {
    return;
  }
  try {
    const parts = url.split(/[#?]/);
    return parts[0].split(".").pop()?.trim().toLowerCase() || "";
  } catch (_e) {
  }
}
